import * as actionTypes from './actionTypes';

export function saveLocale(stateLocation: string, value: string){
    return {
        type: actionTypes.SAVE_LOCALE,
        payload: {
            stateLocation,
            value,
        },
    };
}


// WEBPACK FOOTER //
// ./modules/process-locale/actions/actions.ts